import { AppForm }               from 'components/App/AppForm';
import StandDocumentMediaModel   from 'models/StandDocumentMediaModel';
import React                     from 'react';
import { Button }                from 'antd';
import { List }                  from 'antd';
import { observer }              from 'mobx-react';
import { MailOutlined }          from '@ant-design/icons';
import StandDocumentMessage      from './StandDocumentMessage';
import StandDocumentMessageModel from 'models/StandDocumentMessageModel';
import CardBox                   from 'components/App/CardBox';
import FormattedMessageWrapper   from 'components/App/FormattedMessageWrapper';
import StandDocumentMessageForm  from 'forms/StandDocumentMessageForm';
import rights                    from 'utils/rights';
import { ApiCollection }         from 'collections/ApiCollection';
import { PagedCollection }       from 'collections/PagedCollection';
import ShowModel                 from 'models/ShowModel';
import StandModel                from 'models/StandModel';
import isMessageEditable         from 'utils/isMessageEditable';

const styleIcon = {
  fontSize: '22px',
  marginRight: 6,
};

interface ContentProps {
  editMessage: (message: StandDocumentMessageModel) => void;
  standDocumentMediaCollection: ApiCollection<StandDocumentMediaModel>;
  standDocumentMessagePagedCollection: PagedCollection<StandDocumentMessageModel>;
}

const Content = observer(
  ({
    editMessage,
    standDocumentMediaCollection,
    standDocumentMessagePagedCollection,
  }: ContentProps) => (
    <List
      className="messages-list"
      dataSource={[ ...standDocumentMessagePagedCollection.models ] as StandDocumentMessageModel[]}
      loading={standDocumentMessagePagedCollection.isLoading}
      pagination={{
        current: standDocumentMessagePagedCollection.page,
        defaultCurrent: standDocumentMessagePagedCollection.page,
        hideOnSinglePage: true,
        onChange: page => {
          standDocumentMessagePagedCollection.setPage(page);
          standDocumentMessagePagedCollection.list();
        },
        pageSize: standDocumentMessagePagedCollection.itemsPerPage,
        size: 'small',
        total: standDocumentMessagePagedCollection.total,
      }}
      renderItem={(standDocumentMessage: StandDocumentMessageModel, standDocumentMessageIndex) => {
        const editMessageEnabled =
          isMessageEditable(standDocumentMessageIndex, standDocumentMessage.createdById, standDocumentMessage.createdAtDate)
            ? () => editMessage(standDocumentMessage)
            : null;

        return (
          <List.Item key={standDocumentMessage.id}>
            <StandDocumentMessage
              editMessage={editMessageEnabled}
              lastMessage={
                standDocumentMessageIndex + 1 === standDocumentMessagePagedCollection.length
              }
              standDocumentMediaCollection={standDocumentMediaCollection}
              standDocumentMessage={standDocumentMessage}
            />
          </List.Item>
        );
      }}
      size="large"
    />
  ),
);

interface StandDocumentMessageListBoxProps {
  fetchParentData: () => void;
  show: ShowModel;
  stand: StandModel;
  standDocumentMediaCollection: ApiCollection<StandDocumentMediaModel>;
  standDocumentMessagePagedCollection: PagedCollection<StandDocumentMessageModel>;
}

class StandDocumentMessageListBox extends React.Component<StandDocumentMessageListBoxProps> {
  public render() {
    const {
      show,
      standDocumentMediaCollection,
      standDocumentMessagePagedCollection,
    } = this.props;

    return (
      <CardBox
        bodyStyle={{
          padding: 0,
        }}
        content={
          <Content
            editMessage={this.openStandDocumentMessageFormModal}
            standDocumentMediaCollection={standDocumentMediaCollection}
            standDocumentMessagePagedCollection={standDocumentMessagePagedCollection}
          />
        }
        extra={
          <Button
            disabled={!show.enabled || !rights.for.standDocumentMessage.add}
            htmlType="button"
            onClick={() => {
              this.openStandDocumentMessageFormModal(new StandDocumentMessageModel());
            }}
          >
            <FormattedMessageWrapper id="Envoyer un message" />
          </Button>
        }
        title={
          <>
            <MailOutlined style={styleIcon} /> <FormattedMessageWrapper id="Messages" />
          </>
        }
      />
    );
  }

  private openStandDocumentMessageFormModal = (standDocumentMessage: StandDocumentMessageModel) => {
    const { fetchParentData, stand } = this.props;

    AppForm.open(StandDocumentMessageForm, {
      onSuccess: () => {
        fetchParentData();
      },
      stand: stand,
      standDocumentMessage: standDocumentMessage,
    }, {
      okText: <FormattedMessageWrapper id="Envoyer" />,
      title: <FormattedMessageWrapper id="Envoyer un message" />,
    });
  };
}

export default StandDocumentMessageListBox;
